
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getWebSiteName } from '@/api/main'
import store from '@/store'
export default {
name: 'TLayout',
data() {
username:''
},
components: {
ViewBox,
Tabbar,
TabbarItem,
Group,
Cell
},
created(){
this.username = this.$store.state.user.username
},
methods: {
handleZhuanYeCount() {
this.$router.push({ path: '/t/zhuanyeCount' })
},
handleBanjiCount() {
this.$router.push({ path: '/t/banjiCount' })
},
handleLists() {
this.$router.push({ path: '/t/studentLists' })
},
handleBanji(){
this.$router.push({ path: '/t/studentBanji' })
}
}
}



// WEBPACK FOOTER //
// ./src/views/layout/TLayout.vue